export default {

  // Load store from sessionStorage
  initialiseStore(state) {
    // Replace the state object with the stored item
    this.replaceState(
      Object.assign(state, JSON.parse(sessionStorage.getItem(`store-${state.schema}wrapper`)))
    );
  },

  turnOnMobile(state) {
    state.isMobile = true;
  },

  turnOffMobile(state) {
    state.isMobile = false;
  },

  
  // Preselection -------------------------------------------------------------------

  updatePreselectionBox(state, { sourceBox, isSelected }) {
    state.preselection.boxes.forEach(box => {
      box.isSelected = false;
    });
    state.preselection.boxes[sourceBox].isSelected = isSelected;

    // When no boxes are selected, the row is selected. When a box is selected, the row is no longer selected.
    state.preselection.isSelected = !isSelected;
  },

  updateMultiPreselectionBox(state, { sourceLevel, sourceRow, sourceBox, isSelected }) {
    state.preselection[sourceLevel][sourceRow].boxes.forEach(box => {
      box.isSelected = false;
    });
    state.preselection[sourceLevel][sourceRow].boxes[sourceBox].isSelected = isSelected;

    // When no boxes are selected, the row is selected. When a box is selected, the row is no longer selected.
    //state.preselection[sourceLevel][sourceRow].isSelected = !isSelected;
  },

  unselectPreselectionBoxClick(state, { sourceLevel, sourceRow, sourceBox }) {

    // Unselect all levels and boxes on this level and after
    for (var i = sourceLevel; i < state.preselection.length; i++) {
      state.preselection[i].forEach(row => {
        row.isSelected = false;
        row.boxes.forEach(box => {
          box.isSelected = false;
          box.isActive = false;
        })
      })
    }

    state.preselection[sourceLevel][sourceRow].boxes[sourceBox].isSelected = false;
    state.preselection[sourceLevel][sourceRow].boxes[sourceBox].isActive = false;
    state.preselection[sourceLevel][sourceRow].isSelected = true;
  },

  selectPreselectionBoxClick(state, { sourceLevel, sourceRow, sourceBox, targetLevel, targetRow }) {

    // Unselect all levels and boxes on this level and after
    for (var i = sourceLevel; i < state.preselection.length; i++) {
      state.preselection[i].forEach(row => {
        row.isSelected = false;
        row.boxes.forEach(box => {
          box.isSelected = false;
          box.isActive = false;
        })
      })
    }

    // Remove selection from source row
    state.preselection[sourceLevel][sourceRow].isSelected = false;

    // Add selection to source box
    state.preselection[sourceLevel][sourceRow].boxes[sourceBox].isActive = false;
    state.preselection[sourceLevel][sourceRow].boxes[sourceBox].isSelected = true;

    // Add selection to target row
    //state.preselection[targetLevel][targetRow].isSelected = true;

  },

}
